import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { NavigationUnderline, isNavigationActive } from '../../common/micro-interactions/NavigationUnderline';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate, useLocation, Outlet, Link } from 'react-router-dom';
import { HambergerMenu, Setting2 } from 'iconsax-react';
import logo from '../../../../../public/assets/logo.svg';
import { palette } from '../../../../theme/palette';
import { logout } from '@application/features/auth/authSlice';
import { useAppDispatch } from '@application/store/useStore';
const pages = [
    { label: 'Home', path: '/home' },
    { label: 'Users', path: 'users' },
    { label: 'Hours', path: 'hours' },
    { label: 'Invoices', path: 'invoice' },
    { label: 'Clients', path: 'clients' },
    { label: 'Placement', path: 'placements' }
];
const disabledPages = [''];
const settings = ['Settings', 'My profile', 'Need help?', 'Sign out'];
const theme = palette('light');
export const AdminNaveBar = () => {
    const dispatch = useAppDispatch();
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElSettings, setAnchorElSettings] = React.useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const handleOpenSettingsMenu = (event) => {
        setAnchorElSettings(event.currentTarget);
    };
    const handleCloseSettingsMenu = (setting) => {
        setAnchorElSettings(null);
        if (setting === 'Sign out') {
            dispatch(logout());
            navigate('/login');
        }
        else if (setting === 'Settings') {
            navigate('/settings');
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(AppBar, { className: 'navbar', position: 'fixed', sx: { background: theme.background.neutral, px: 1, pt: 1 }, children: _jsx(Container, { maxWidth: false, sx: { background: '#FFFFFF', borderRadius: '25px' }, children: _jsxs(Toolbar, { disableGutters: true, style: { height: '80px' }, children: [_jsx("img", { src: logo, alt: 'QGroup', style: { maxWidth: 'min(180px, 35vw)', height: 'auto' } }), _jsx(Box, { sx: { flexGrow: 1 } }), _jsx(Box, { sx: {
                                    display: { xs: 'none', md: 'none', lg: 'flex', xl: 'flex' }
                                }, children: _jsx(NavigationUnderline, { items: pages.map(page => ({ ...page, disabled: disabledPages.includes(page.label) })) }) }), _jsx(Box, { sx: { flexGrow: 1 } }), _jsxs(Box, { sx: { display: 'flex', gap: '15px' }, children: [_jsx(Box, {}), _jsx(Box, { children: _jsx(IconButton, { "aria-label": 'settings', onClick: handleOpenSettingsMenu, sx: { border: '1px solid #D7D7D7' }, children: _jsx(Setting2, { style: { color: '#141414' } }) }) }), _jsx(Menu, { sx: { mt: 1 }, id: 'settings-menu', anchorEl: anchorElSettings, open: Boolean(anchorElSettings), onClose: handleCloseSettingsMenu, children: settings.map((setting) => (_jsx(MenuItem, { sx: {
                                                '&:hover': {
                                                    color: theme.primary.main
                                                }
                                            }, onClick: () => handleCloseSettingsMenu(setting), children: setting }, setting))) }), _jsxs(Box, { sx: { display: { xs: 'flex', lg: 'none' } }, children: [_jsx(IconButton, { size: 'large', "aria-label": 'Open navigation', "aria-expanded": Boolean(anchorElNav), "aria-controls": 'menu-appbar', "aria-haspopup": 'true', onClick: handleOpenNavMenu, color: 'inherit', children: _jsx(HambergerMenu, { style: { color: theme.secondary.darker } }) }), _jsx(Menu, { id: 'menu-appbar', anchorEl: anchorElNav, anchorOrigin: {
                                                    vertical: 'bottom',
                                                    horizontal: 'left'
                                                }, keepMounted: true, transformOrigin: {
                                                    vertical: 'top',
                                                    horizontal: 'left'
                                                }, open: Boolean(anchorElNav), onClose: handleCloseNavMenu, sx: { display: { xs: 'block', lg: 'none' } }, children: pages.map((page) => (_jsx(MenuItem, { component: Link, to: `/${page.path.replace(/^\/+/, '')}`, "aria-current": isNavigationActive(location.pathname, page.path) ? 'page' : undefined, selected: isNavigationActive(location.pathname, page.path), sx: {
                                                        '&:hover': {
                                                            color: theme.primary.main
                                                        }
                                                    }, onClick: handleCloseNavMenu, children: _jsx(Typography, { textAlign: 'center', children: page.label }) }, page.label))) })] })] })] }) }) }), _jsx(Outlet, {})] }));
};
